import * as React from "react";
import ReactPlayer from "react-player";
// import { pure } from 'recompose'

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { localUrl, classnames } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-player
   * @infos "https://reactjs.org"
   */
  return (
    <ReactPlayer
      url={localUrl}
      className={classnames}
      config={{ file: { attributes: { controlsList: "nodownload" } } }}
      width="100%"
      height="calc(100% - 28px)"
      controls={true}
      playing={true}
    />
  );
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  localUrl?: any;
  classnames?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/hls/component.tsx